import { z } from "zod/v4";

import { UIMessageSchema } from "../context-schemas";
import { BaseNodeExecutionResultSchema } from "../node-execution-result";

import {
  BaseNodeDefinitionConfigSchema,
  BaseNodeDefinitionSchema,
} from "./base-node";

export const ExportMessageNodeConfigSchema =
  BaseNodeDefinitionConfigSchema.extend({
    s3Bucket: z.string(),
    s3Folder: z.string(),
    s3Key: z.string(),
    ttlDays: z.number().optional(),
  });

export const ExportedMessageS3Schema = z.object({
  ttl: z.number().optional(),
  expiresAt: z.string().optional(),
  createdAt: z.number(),
  sessionId: z.string(),
  workflowId: z.string(),
  message: UIMessageSchema,
});
export type ExportedMessageS3 = z.infer<typeof ExportedMessageS3Schema>;

export const ExportMessageNodeDefinitionSchema =
  BaseNodeDefinitionSchema.extend({
    type: z.literal("export"),
    config: ExportMessageNodeConfigSchema,
  });

export const ExportMessageNodeResultSchema =
  BaseNodeExecutionResultSchema.extend({
    type: z.literal("export"),
  });

export type ExportMessageNodeConfig = z.infer<
  typeof ExportMessageNodeConfigSchema
>;
export type ExportMessageNodeDefinition = z.infer<
  typeof ExportMessageNodeDefinitionSchema
>;
export type ExportMessageNodeResult = z.infer<
  typeof ExportMessageNodeResultSchema
> & {
  s3Location?: {
    bucket: string;
    key: string;
    url?: string;
  };
  exportedData?: Record<string, unknown>;
};
